import _ from 'lodash';

class TokenEventsManager {
    constructor(settings) {
        this._settings = settings;
        this.onTokenExpiringCallbacks = [];
        this.onExpiredCallbacks = [];
    }

    onExpireCb(onExpiredCallback) {
        this.onExpiredCallbacks.push(onExpiredCallback);
    }

    tokenExpiringCb(tokenExpiringCallback) {
        this.onTokenExpiringCallbacks.push(tokenExpiringCallback);
    }

    tokenExpiring(startTokenWatch) {
        _.forEach(this.onTokenExpiringCallbacks, (cb)=>{
            cb();
        });
        startTokenWatch();
    }

    tokenExpired() {
        _.forEach(this.onExpiredCallbacks, (cb)=>{
            cb();
        });
    }
}

export default TokenEventsManager;

